module.exports = __webpack_public_path__ + "img/thumbnail_BrownThroatedSloth_u_normal.f3881ef0.png";